export enum ToolMode {
  Select = 'select',
  Pan = 'pan',
  CreateNode = 'create-node',
  ResizeNode = 'resize-node',
  CreateEdge = 'create-edge',
}
